import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=5d12d8ec&scoped=true&"
import script from "./Conference.vue?vue&type=script&lang=js&"
export * from "./Conference.vue?vue&type=script&lang=js&"
import style0 from "./Conference.vue?vue&type=style&index=0&id=5d12d8ec&lang=scss&scoped=true&"
import style1 from "./Conference.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12d8ec",
  null
  
)

export default component.exports